// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"clubPayments__gradient-bg5__czz8h","section":"clubPayments__section__eEEBZ","clubName":"clubPayments__clubName__mAIqk"};